<template>
  <div>
    <CRow class="justify-content-center" v-if="isLoading"> 
        <div class="spinner-grow text-warning m10" role="status" v-for="i in [ 1, 2, 3]"  v-bind:key="i">
            <span class="sr-only">Cargando...</span>
        </div>
    </CRow>
    <CRow v-if="events.length">
      <CCol sm="12">
          <CCard>
            <CCardHeader>
              <h5 class="text-warning">
                Eventos APREU
              </h5>
            </CCardHeader>
            <CCardBody>
              <table class="table table-sm table-striped table-bordered">
                <thead>
                  <tr>
                    <th>Nombre</th>
                    <th>Fecha</th>
                    <th>Participantes esperados</th>
                    <th>Participantes individuales</th>
                    <th>Participantes registrados</th>
                    <th>Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(event, index) in events" v-bind:key="index">
                    <td>{{event.name}}</td>
                    <td>{{event.date_event}}</td>
                    <td>{{event.external_assistants_requested}}</td>
                    <td>{{event.external_assistants_records}}</td>
                    <td>{{event.external_assistants_registered}}</td>
                    <td style="min-width:200px !important" class="pt10">
                        <CButton color="warning" size="sm" @click="getMembers(event.list_id)"
                        title="Participantes"
                        style="padding: 0.3rem 0.5rem;margin-right: 10px;">
                          <font-awesome-icon :icon="['fas', 'user']" />       
                        </CButton>

                        <CButton color="info" size="sm" @click="updateList(event.list_id, event.name)"
                        title="Actualizar lista"
                        style="padding: 0.3rem 0.5rem;margin-right: 10px;">
                          <font-awesome-icon :icon="['fas', 'sync']" />       
                        </CButton>

                        <CButton color="success" size="sm" @click="updateAndSendEmails(event.list_id, event.name)"
                        title="Añadir nuevos y enviar QR"
                        style="padding: 0.3rem 0.5rem;margin-right: 10px;">
                          <font-awesome-icon :icon="['fas', 'envelope']" />       
                        </CButton>

                        <CButton color="danger" size="sm" @click="closeEvent(event.id, event.name)" 
                        title="Terminar evento"
                        style="padding: 0.3rem 0.5rem;margin-right: 10px;">
                          <font-awesome-icon :icon="['fas', 'window-close']" />    
                        </CButton>

                        <CButton color="success" size="sm" @click="onOpenDownloadEvent(event.id, event.name)" 
                        title="Descargar reporte"
                        style="padding: 0.3rem 0.5rem;">
                          <font-awesome-icon :icon="['fas', 'file-excel']" />
                        </CButton>

                        <download-excel v-c-tooltip="{content: 'Exportar asistentes'}"
                            :ref="'excelReport_'+event.id"
                            class="full-hidden"
                            worksheet="Asistentes Evento"
                            name="asistentes_evento.xls"
                            :fetch="fetchData"
                            :fields="fetchFields()"
                            :before-generate="startDownload"
                            :before-finish="finishDownload">
                            <font-awesome-icon :icon="['fas', 'file-excel']" />
                        </download-excel>
                    </td>
                  </tr>
                </tbody>
              </table>
            </CCardBody>
          </CCard>
      </CCol>
    </CRow>

    <CCol sm="12">
      <CRow>
        <CCard style="width:100%">
          <CCardHeader>
                <CRow style="justify-content:space-between">
                  <h5 class="text-warning">
                    Participantes {{eventSelected.name ? 'de ' + eventSelected.name : ''}}
                  </h5>
                  <CForm inline class="float-right" v-on:submit.prevent="findByNameOrEmail">
                    <CInput class="mr-2 my-0" placeholder="Buscar" v-model="nameMember" size="sm">                      
                        <template #append>
                            <CButton class="mr-2" color="info" size="sm" @click="findByNameOrEmail">
                                <font-awesome-icon :icon="['fas', 'search']" />   
                            </CButton>
                        </template>
                    </CInput>
                  </CForm>
                </CRow>
              </CCardHeader>
        </CCard>
      </CRow>
      <CRow class="justify-content-center" v-if="isLoadingMembers"> 
          <div class="spinner-grow text-warning m10" role="status" v-for="i in [ 1, 2, 3]"  v-bind:key="i">
              <span class="sr-only">Cargando Participantes...</span>
          </div>
      </CRow>
      <CRow v-if="members.length">
        <CCol sm="12">
            <CCard>
              <CCardBody>
                <table class="table table-sm table-striped table-bordered">
                  <thead>
                    <tr>
                      <th>Nombre</th>
                      <th>Relación</th>
                      <th>Email</th>
                      <th>Registrado</th>
                      <th>Acciones</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(member, index) in members" v-bind:key="index">
                      <td>{{member.name}}</td>
                      <td>{{member.relationship}}</td>
                      <td>{{member.email}}</td>
                      <td>
                        <CButton v-if="isMemberAssisted(member.metadata)"
                        color="success" shape="pill" style="height: 40px; width: 40px;" @click="null">
                            <font-awesome-icon  :icon="['fas', 'check']" /> 
                        </CButton>
                      </td>
                      <td style="min-width:200px !important" class="pt10">
                          <CButton color="warning" size="sm" @click="sendEmail(member.id)"
                          title="Enviar QR al correo" 
                          style="margin-top:-8px;padding: 0.3rem 0.5rem;margin-right: 10px;">
                            <font-awesome-icon :icon="['fas', 'qrcode']"></font-awesome-icon>
                          </CButton>
                          <CButton color="success" size="sm" @click="updateAssistants(member.id)"
                          title="Editar asistencia"
                          style="margin-top:-8px;padding: 0.3rem 0.5rem;">
                            <font-awesome-icon :icon="['fas', 'user-check']"></font-awesome-icon> 
                          </CButton>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </CCardBody>
            </CCard>
        </CCol>
      </CRow>
      <CRow>
        <!-- Paginator -->
        <CCol sm="12">
            <pagination v-if="pagination.last_page > 1" :pagination="pagination" :offset="5" @paginate="paginatorClick($event)"></pagination>
        </CCol>
      </CRow>
    </CCol>
  </div>
</template>
<script>
import Loading from 'vue-loading-overlay';
import downloadExcel from "vue-json-excel";
export default {
  name: 'Eventos',
  components: { Loading, downloadExcel },
  data () {
    return {
      id: 0,
      eventId: 0,
      router: this.$router,
      authData: this.$AuthApiService.getDataLocalStorage(),
      isLoading: false,
      isLoadingMembers: false, 
      asistentes_reporte: [],
      basePath: process.env.VUE_APP_API_URL,
      events: [],
      members: [],
      membersPage: 0,
      memberPages: 0,
      listId: 0,
      nameMember : '',
      lastNameMember: '',
      eventSelected: {},
      pagination: { current_page: 1, last_page: 1 },
      isByName: false,
      excelReportId: 0
    };
  },
  methods: {
    queryString(obj) {
        var str = [];
        for (var p in obj) {
            if (obj.hasOwnProperty(p) && obj[p] != '' && obj[p] != null) {
                str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
            }
        }
        return str.join("&");
    },
    async onOpenDownloadEvent(id, name) {
      const result = await this.$swal({
          title: `¿Quieres descargar el reporte del evento ${name}?`,
          text: "",
          icon: 'info', 
          buttons: [
            'Cancelar',
            'Sí, descargar'
          ]
      });

      if(result) {
        this.excelReportId = id;
        const vueObject = this.$refs[`excelReport_${id}`];
        vueObject[0].generate();
      }
    },
    startDownload(){
        this.isLoading = true;
    },
    finishDownload(){
        this.isLoading = false;
    },
    async fetchData() {
      var token = await this.$AuthApiService.getAccessToken();
      var response = await this.$axios.get(this.basePath + `api/external-events/participant-report?id=${this.excelReportId}`, 
      {
        headers: { 'Authorization': token.token_type + ' ' + token.access_token }
      });
      console.log(response.data);
      var result = response.data.map((x) => { 
        return {
          ...x,
          invitaciones_solicitadas:this.getCountOfElements(response.data, x),
          invitaciones_registradas:this.getRegisteredElement(response.data,x),
          asistio:this.isMemberAssistedNumber(x.metadata)
        } 
      });
      return result;
    },
    getRegisteredElement(elements, identifier) {
      if(identifier.relacion == "EGRESADO" || identifier.relacion == "personal")
      var participant = elements.filter(y => y.nombre_invitado == identifier.nombre_invitado);
      else
      return 0;

      var result = 0;
      for (const iterator of participant) {
        result+=this.isMemberAssistedNumber(iterator.metadata);
      }

      return result;

    },
    getCountOfElements(elements, identifier) {
      if(identifier.relacion == "EGRESADO" || identifier.relacion == "personal")
      return elements.filter(y => y.nombre_invitado == identifier.nombre_invitado).length;

      return 0;
    },
    isMemberAssistedNumber(metadataString) {
      var metadata = JSON.parse(metadataString);

      if(metadata.totalScanning > 0)
      return 1;

      return 0;
    },
    fetchFields() {
        let fields = {

        };

        fields['NOMBRE'] = "evento";
        fields['INVITADO_POR'] = "invitado_por";
        fields['NOMBRE_INVITADO'] = "nombre_invitado";
        fields['CORREO_ELECTRONICO'] = "correo_electronico";
        fields['RELACION'] = "relacion";
        fields['INVITACIONES_SOLICITADAS'] = "invitaciones_solicitadas";
        fields["INVITACIONES_REGISTRADAS"] = "invitaciones_registradas";
        fields['ASISTIO'] = "asistio";
        fields['ULTIMA_ACTUALIZACION'] = "ultima_actualizacion"

        for (const key of this.asistentes_reporte) {
            fields[this.makeReadable(key).toUpperCase()] = key;
        }
        return fields;
    },
    encriptar(text) {
        return cryptoJs.encrypt(text.toString())
    },
    makeReadable(value) {
        return value.replaceAll(/_/g,' ');
    },
    async getAllEvents(ignoreSet = false) {
      this.isLoading = true;
      this.events = [];
      if (!ignoreSet) {
        this.members = [];
        this.memberPages = 0;
        this.membersPage = 0;
      }
      var token = await this.$AuthApiService.getAccessToken();
      var response = await this.$axios.post(this.basePath + 'api/biu/external-events',{
        "active": 1
      }, 
      {
        headers: { 'Authorization': token.token_type + ' ' + token.access_token }
      });

      this.events = [...response.data.events];
      this.isLoading = false;

    },
    isMemberAssisted(metadataString) {
      var metadata = JSON.parse(metadataString);

      if(metadata.totalScanning > 0)
      return true;

      return false;
    },
    async getMembers(listId, page = 0, limit = 30) {

      this.eventSelected = this.events.find(x => x.list_id == listId);
      this.isLoadingMembers= true;
      this.members = [];
      this.memberPages = 0;
      this.memberPage = 0;

      this.listId = listId;

      var token = await this.$AuthApiService.getAccessToken();
      var response = await this.$axios.post(this.basePath + 'api/biu/external-events/members',{
        "page": page,
        "limit": limit,
        "listId": listId
      }, 
      {
        headers: { 'Authorization': token.token_type + ' ' + token.access_token }
      });

      this.memberPages = response.data.pages;
      this.membersPage = response.data.page;
      this.members = [...response.data.members];
      this.generatePagination(this.membersPage, this.memberPages);
      this.isByName = false;
      this.isLoadingMembers = false;
    },
    async sendEmail(memberId) {
      if (!memberId)
      return;

      // Do a confirm
      const result = await this.$swal({
          title: '¿Enviar el QR al correo?',
          text: "",
          icon: 'info', 
          buttons: [
            'Cancelar',
            'Sí, enviar'
          ]
      });

      if (result) {
        var token = await this.$AuthApiService.getAccessToken();
        var response = await this.$axios.post(this.basePath + 'api/biu/external-events/email',{
          "memberId": memberId,
        }, 
        {
          headers: { 'Authorization': token.token_type + ' ' + token.access_token }
        });

        // Do a own dialog with response.
        if (response.data.emailsSended) {
          this.showDialog("Envío exitoso", "Se ha enviado el correo correctamente", "success");
        } else if (response.data.error || response.data.emailError == 1) {
          this.showDialog("Error", "No fue posible enviar el correo, intente nuevamente", "error");
        } else if (response.data.emailIgnored) {
          this.showDialog("Advertencia", "No es posible enviar el correo debido a que el registro no presenta un correo válido", "warning");
        }
      }
    },
    async updateList(listId, nameEvent, reload = true) {

      if (!listId)
      return;

      const result = await this.$swal({
          title: '¿Buscar participantes?',
          text: `Se buscaran nuevos elementos registrados en ${nameEvent}`,
          icon: 'info', 
          buttons: [
            'Cancelar',
            'Sí, Buscar'
          ]
      });

      if (!result)
      return;

      this.$swal({
        title: 'Buscando nuevos elementos',
        text: 'Esto puede tardar varios minutos',
        icon: 'info',
        buttons: false,
      });

      var token = await this.$AuthApiService.getAccessToken();
      var response = await this.$axios.post(this.basePath + 'api/external-events/newest',{
          "listId": listId,
          "limit": 100,
          "upload": 1
        }, 
      {
        headers: { 'Authorization': token.token_type + ' ' + token.access_token }
      });

      if (this.$swal.close)
      this.$swal.close();

      if (response.data.error) {
        if (reload)
        this.showDialog("Error","No fue posible obtener nuevos participantes, intente más tarde", "error");
        else 
        return { error: 1};
      } else {
        var registered = response.data.registered;
        var records = response.data.records;
        const t = this.showDialog("Participantes registrados", 
        `Se han obtenido un total de ${registered} participantes nuevos. Con ${records} registros individuales.`, "success", reload);
        // Reload the window
        if (reload) {
          await t;
          window.location.reload();
        }
        else {
          return {
            registered: registered,
            records: records
          };
        }
      }
    },
    requestEmail(listId, token, sended = 0, ignored = 0, errors = 0) {
      return this.$axios.post(this.basePath + 'api/external-events/batch-email',{
          "listId": listId,
          "page": 0,
          "limit": 100,
          "sended": sended,
          "ignored": ignored,
          "errors": errors
        }, 
      {
        headers: { 'Authorization': token.token_type + ' ' + token.access_token }
      });
    },
    async sendBatchEmails(listId, responseP = null) {
      this.showDialog("Enviado correos", "Esto puede tomar varios minutos","info",false);

      var token = await this.$AuthApiService.getAccessToken();
      var response = await this.requestEmail(listId, token);

      if(response.data.error) {
        this.showDialog("Error","No fue posible enviar los correos a los nuevos participantes, intente más tarde", "error");
        return;
      } else {
        var totalPages = response.data.pages;
        var sended = response.data.sended;
        var ignored = response.data.ignored;
        var errors = response.data.errors;

        for (let index = 1; index < totalPages; index++) {
          response = await this.requestEmail(listId, token, sended,ignored,errors);
          if (this.$swal.close)
          this.$swal.close();
        }

        if (responseP)
        await this.showDialog("Éxito", 
        `Se ha completado el envio de correos con un total de ${responseP.registered} registros nuevos y un total de ${response.data.sended} correos enviados`);
        else
        await this.showDialog("Éxito", `Se ha completado el envio de correos con un total de ${response.data.sended} enviados`);

        window.location.reload();

      }
    },
    async closeEvent(id, name) {
        // Confirm
        const result = await this.$swal({
          title: 'Cerrar evento ',
          text: "¿Quieres cerrar ''" + name +"'? Esta acción no puede ser modificada",
          icon: 'warning', 
          buttons: [
            'Cancelar',
            'Sí, cerrar evento'
          ]
      });

      if (result) {
        var token = await this.$AuthApiService.getAccessToken();
        var response = await this.$axios.post(this.basePath + 'api/biud/external-events/close',{
          "id": id,
          }, 
        {
          headers: { 'Authorization': token.token_type + ' ' + token.access_token }
        });

        if (response.data && response.data.error) {
          this.showDialog("Error","No fue posible cerrar el evento, intente más tarde", "error");
          return;
        } else {
          await this.showDialog("Éxito", "El evento fue cerrado correctamente", "success");
          window.location.reload();
        }

      }
    },
    async updateAndSendEmails(listId, nameEvent) {
      const updated = await this.updateList(listId, nameEvent, false);
      if (updated.error)
      return;

      if (this.$swal.close)
      this.$swal.close();

      const sended = await this.sendBatchEmails(listId, updated);
    },
    async updateAssistants(externalMemberAssistantsId) {

      if (!externalMemberAssistantsId)
      return;

      this.showDialog("Buscando información", "Buscando información del invitado. Espere un momento", "info", false);

      var token = await this.$AuthApiService.getAccessToken();
      var response = await this.$axios.post(this.basePath + 'api/external-events/data-member',{
        "id": externalMemberAssistantsId+"-"+this.eventSelected.id,
        }, 
      {
        headers: { 'Authorization': token.token_type + ' ' + token.access_token }
      });

      if(this.$swal.close)
      this.$swal.close();

      if (response.data.error) {
        this.showDialog("Error","No fue posible obtener información del invitado, intente más tarde", "error");
        return;
      } else {
        var event = {...response.data.event};
        // var guessData = {...response.data.external};
        var members = [...response.data.members];
        // var currentScanned = {...response.data.person_scanned};

        // Show dialog data with all info
        const result = await this.$swal({
          title: event.name,
          icon: 'info',
          text: `
          Invitado:
          ${this.displayMembers(members.filter(x => x.id == externalMemberAssistantsId))}
          `,
          // content: {
          //   element: "input",
          //   attributes: {
          //     placeholder: "Asistentes",
          //     type: "number",
          //     value: guessData.assistants_recorded
          //   },
          // },
          buttons: [
            'Cancelar',
            'Sí, Registrar asistencia'
          ]
        });

        if (result || result === 0 || result === "0") {
          
          this.showDialog("Realizando operación", "Se está actualizando los datos del invitado. Espere un momento", "info", false);

          var responseUpdate = await this.$axios.post(this.basePath + 'api/external-events/register-action',{
            "external_member_id": externalMemberAssistantsId,
            "external_event_id": this.eventSelected.id,
            "assitants": 1,
            "email": this.authData.user.email
            }, 
          {
            headers: { 'Authorization': token.token_type + ' ' + token.access_token }
          });

          if(this.$swal.close)
          this.$swal.close();

          if (responseUpdate.data.error) {
            this.showDialog("Error","No fue posible actualizar la información del invitado, intente más tarde", "error");
            return;
          } else {
            this.showDialog("Realizando operación", "Actualizando listas", "info", false);
            await this.paginatorClick(this.pagination.current_page);
            await this.getAllEvents(true);

            if(this.$swal.close)
            this.$swal.close();
            await this.showDialog("Éxito", "Información actualizada", "success");
          }


        }

      }
    },
    displayMembers(members) {
      let result = "";
      members.forEach(member => {
        result += 
        `
        ${member.name} (${member.relationship})
        `;
      });

      return result;
    },
    showDialog(title, msg, icon, showButton = true) {
      return this.$swal({
          title: title,
          text: msg,
          icon: icon,
          buttons: showButton
      });
    },
    async findByNameOrEmail(n, page = 0, limit = 30, name = '') {
      if (!this.eventSelected)
      return;

      if (this.nameMember)
      this.lastNameMember = this.nameMember;

      this.isLoadingMembers= true;
      this.members = [];
      this.memberPages = 0;
      this.membersPage = 0;
      var token = await this.$AuthApiService.getAccessToken();

      var response = name || this.nameMember ? await this.$axios.post(this.basePath + 'api/biu/external-events/members/name',{
        "name": name ? name : this.nameMember,
        "page": page,
        "limit": limit,
        "listId": this.eventSelected.list_id
      }, 
      {
        headers: { 'Authorization': token.token_type + ' ' + token.access_token }
      }) : await this.$axios.post(this.basePath + 'api/biu/external-events/members',{
        "page": page,
        "limit": limit,
        "listId": this.eventSelected.list_id
      }, 
      {
        headers: { 'Authorization': token.token_type + ' ' + token.access_token }
      });

      this.memberPages = response.data.pages;
      this.membersPage = response.data.page;
      this.members = [...response.data.members];
      this.generatePagination(this.membersPage, this.memberPages);
      this.isByName = name || this.nameMember ? true : false;
      this.isLoadingMembers = false;
    },
    generatePagination(page, pages) {
      this.pagination = {
        current_page : page + 1,
        last_page: pages,
      };
    },
    paginatorClick(pageSelected) {
      if (this.isByName) {
        return this.findByNameOrEmail(null, pageSelected - 1, 30, this.lastNameMember);
      } else {
        return this.getMembers(this.eventSelected.list_id, pageSelected - 1, 30);
      }
    },
  },
  mounted() {
    this.getAllEvents();
  },
  filters: {
        capitalize: function (value) {
            if (!value) return ''
            value = value.toString().toLowerCase()
            return value.charAt(0).toUpperCase() + value.slice(1)
        }
    }
}
</script>